$('#sector').on('change', function () {
    window.location.href = $(this).children('option:selected').val();
});
